/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class s{constructor(s,t,i,e,h,o,r,c){this.id=s,this.mbs=t,this.obb=i,this.version=e,this.resources=h,this.children=o,this.lodSelection=r,this.numFeatures=c}}export{s as ValidatedNode};
